var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{staticClass:"secondary black--text",attrs:{"app":"","height":"20"}},[_vm._t("center")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }